import { FC, useCallback } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';

import { trackViewMoreClick } from '../recentHistoryTracking';
import { ACTION_LABEL } from './constants';

import styles from './RecentlyViewedItemsWrapper.scss';

export const RecentlyViewedItemsWrapper: FC<{
    wrapperClassName?: string;
    centerTitle?: boolean;
    isSwiperCarousel?: boolean;
    actionLabel?: string;
    trackViewMoreClick?: typeof trackViewMoreClick;
}> = ({
    wrapperClassName,
    children,
    actionLabel = ACTION_LABEL,
    centerTitle,
    isSwiperCarousel = false,
    ...props
}) => {
    const onViewMoreClick = useCallback(() => {
        (props.trackViewMoreClick || trackViewMoreClick)({ actionLabel });
    }, [actionLabel, props.trackViewMoreClick]);

    const wrapperStyles = classnames(wrapperClassName, {
        [styles.centerTitle]: centerTitle,
        [styles.isSwiperCarousel]: isSwiperCarousel,
    });

    return (
        <div className={wrapperStyles}>
            <div className={styles.header}>
                <HeadingLevel>
                    {Heading => (
                        <Heading className={styles.title}>
                            <FormattedMessage
                                id="RecentlyViewedItemsCarousel.title"
                                defaultMessage="Recently Viewed"
                            />
                        </Heading>
                    )}
                </HeadingLevel>
                <Link
                    className={styles.viewMore}
                    href="/favorites/viewed/"
                    onClick={onViewMoreClick}
                >
                    <FormattedMessage
                        id="RecentlyViewedItemsCarousel.viewMoreCta"
                        defaultMessage="View More"
                    />
                </Link>
            </div>
            {children}
        </div>
    );
};
